mutation SetResponsivenessOnSentence($sentence: ID!, $responsive: Boolean!) {
  setResponsivenessOnSentence(sentence: $sentence, responsive: $responsive) {
    ok
    errors
  }
}
